import { Draggable, isNullOrUndefined } from '@syncfusion/ej2-base';
import { removeClass } from '@syncfusion/ej2-base';
import { remove, closest as closestElement, classList, extend } from '@syncfusion/ej2-base';
import { parentsUntil, removeElement, getPosition, addRemoveActiveClasses, isActionPrevent } from '../base/util';
import { resetRowIndex } from '../base/util';
import * as events from '../base/constant';
import { Scroll } from '../actions/scroll';
import * as literals from '../base/string-literals';
// eslint-disable-next-line valid-jsdoc
/**
 *
 * Reorder module is used to handle row reordering.
 *
 * @hidden
 */
export class RowDD {
    /**
     * Constructor for the Grid print module
     *
     * @param {IGrid} parent - specifies the IGrid
     * @hidden
     */
    constructor(parent) {
        this.selectedRows = [];
        this.isOverflowBorder = true;
        this.selectedRowColls = [];
        this.isRefresh = true;
        this.isReplaceDragEle = true;
        this.istargetGrid = false;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this.helper = (e) => {
            const gObj = this.parent;
            const target = this.draggable.currentStateTarget;
            const visualElement = this.parent.createElement('div', {
                className: 'e-cloneproperties e-draganddrop e-grid e-dragclone',
                styles: 'height:"auto", z-index:2, width:' + gObj.element.offsetWidth
            });
            const table = this.parent.createElement('table', { styles: 'width:' + gObj.element.offsetWidth, attrs: { role: 'grid' } });
            const tbody = this.parent.createElement(literals.tbody, { attrs: { role: 'rowgroup' } });
            if (document.getElementsByClassName('e-griddragarea').length ||
                (gObj.rowDropSettings.targetID && ((!target.classList.contains('e-selectionbackground')
                    && gObj.selectionSettings.type !== 'Single') || !parentsUntil(target, 'e-rowcell'))) ||
                (!gObj.rowDropSettings.targetID && !parentsUntil(target, 'e-rowdragdrop'))) {
                return false;
            }
            if (gObj.rowDropSettings.targetID &&
                gObj.selectionSettings.mode === 'Row' && gObj.selectionSettings.type === 'Single') {
                gObj.selectRow(parseInt(this.draggable.currentStateTarget.parentElement.getAttribute(literals.dataRowIndex), 10));
            }
            this.startedRow = closestElement(target, 'tr').cloneNode(true);
            if (this.parent.isFrozenGrid()) {
                const nodes = [].slice.call(this.startedRow.querySelectorAll('.e-rowcell'));
                for (let i = 0; i < nodes.length; i++) {
                    removeClass([nodes[parseInt(i.toString(), 10)]], ['e-leftfreeze', 'e-freezeleftborder', 'e-fixedfreeze', 'e-freezerightborder', 'e-rightfreeze', 'e-unfreeze']);
                    nodes[parseInt(i.toString(), 10)].removeAttribute('style');
                }
            }
            this.processArgs(target);
            const args = {
                selectedRow: this.rows, dragelement: target,
                cloneElement: visualElement, cancel: false, data: this.rowData
            };
            const selectedRows = gObj.getSelectedRows();
            gObj.trigger(events.rowDragStartHelper, args);
            const cancel = 'cancel';
            if (args[`${cancel}`]) {
                return false;
            }
            removeElement(this.startedRow, '.e-indentcell');
            removeElement(this.startedRow, '.e-detailrowcollapse');
            removeElement(this.startedRow, '.e-detailrowexpand');
            this.removeCell(this.startedRow, literals.gridChkBox);
            const exp = new RegExp('e-active', 'g'); //high contrast issue
            this.startedRow.innerHTML = this.startedRow.innerHTML.replace(exp, '');
            tbody.appendChild(this.startedRow);
            if (gObj.getSelectedRowIndexes().length > 1 && this.startedRow.hasAttribute('aria-selected')) {
                const dropCountEle = this.parent.createElement('span', {
                    className: 'e-dropitemscount', innerHTML: '' + selectedRows.length
                });
                visualElement.appendChild(dropCountEle);
            }
            const ele = closestElement(target, 'tr').querySelector('.e-icon-rowdragicon');
            if (ele) {
                ele.classList.add('e-dragstartrow');
            }
            table.appendChild(tbody);
            visualElement.appendChild(table);
            gObj.element.appendChild(visualElement);
            return visualElement;
        };
        this.dragStart = (e) => {
            const gObj = this.parent;
            if (gObj.enableVirtualization && gObj.allowGrouping && gObj.groupSettings.columns.length &&
                !isNullOrUndefined(e.target.closest('tr'))) {
                const dragTrs = e.dragElement.querySelectorAll('tr');
                const indentCells = e.target.closest('tr').querySelectorAll('.e-indentcell');
                for (let i = 0; i < dragTrs.length; i++) {
                    for (let j = 0; j < indentCells.length; j++) {
                        const cloneIndentCell = indentCells[parseInt(j.toString(), 10)].cloneNode(true);
                        dragTrs[parseInt(i.toString(), 10)].insertBefore(cloneIndentCell, dragTrs[parseInt(i.toString(), 10)].firstElementChild);
                    }
                }
            }
            if (gObj.element.classList.contains('e-childgrid')) {
                const parentGrid = this.getParentGrid(gObj.element);
                parentGrid.appendChild(e.dragElement);
                gObj.element.appendChild(gObj.createElement('div', { className: 'e-drag-ref' }));
            }
            document.body.classList.add('e-prevent-select');
            if (document.getElementsByClassName('e-griddragarea').length) {
                return;
            }
            const target = e.target;
            const spanCssEle = this.parent.element.querySelector('.e-dropitemscount');
            if (this.parent.getSelectedRecords().length > 1 && spanCssEle) {
                spanCssEle.style.left = this.parent.element.querySelector('.e-cloneproperties table')
                    .offsetWidth - 5 + 'px';
            }
            this.processArgs(target);
            gObj.trigger(events.rowDragStart, {
                rows: this.rows, target: e.target,
                draggableType: 'rows', fromIndex: parseInt(this.rows[0].getAttribute(literals.dataRowIndex), 10),
                data: (this.rowData[0] && Object.keys(this.rowData[0]).length > 0) ? this.rowData : this.currentViewData()
            });
            this.dragStartData = this.rowData;
            const dropElem = document.getElementById(gObj.rowDropSettings.targetID);
            if (gObj.rowDropSettings.targetID && dropElem && dropElem.ej2_instances &&
                dropElem.ej2_instances[0].getModuleName() === 'grid') {
                dropElem.ej2_instances[0].getContent().classList.add('e-allowRowDrop');
            }
        };
        this.drag = (e) => {
            const gObj = this.parent;
            this.isDropGrid = this.parent;
            this.istargetGrid = false;
            if (this.parent.rowDropSettings.targetID) {
                const dropElement = document.getElementById(gObj.rowDropSettings.targetID);
                this.isDropGrid = dropElement.ej2_instances[0];
                if (parentsUntil(e.target, 'e-grid')) {
                    this.istargetGrid = this.parent.rowDropSettings.targetID === parentsUntil(e.target, 'e-grid').id;
                }
            }
            let cloneElement = this.parent.element.querySelector('.e-cloneproperties');
            if (gObj.element.classList.contains('e-childgrid')) {
                const parentGrid = this.getParentGrid(gObj.element);
                cloneElement = parentGrid.querySelector('.e-cloneproperties');
            }
            const target = this.getElementFromPosition(cloneElement, e.event);
            classList(cloneElement, ['e-defaultcur'], ['e-notallowedcur', 'e-movecur', 'e-grabcur']);
            this.isOverflowBorder = true;
            this.hoverState = gObj.enableHover;
            const trElement = parentsUntil(target, 'e-grid') ? closestElement(e.target, 'tr') : null;
            if (!e.target) {
                return;
            }
            this.processArgs(target);
            const args = {
                rows: this.rows, target: target, draggableType: 'rows',
                data: this.rowData, originalEvent: e, cancel: false
            };
            gObj.trigger(events.rowDrag, args);
            this.stopTimer();
            if (args.cancel) {
                return;
            }
            gObj.element.classList.add('e-rowdrag');
            if (trElement && (parentsUntil(target, 'e-grid').id === cloneElement.parentElement.id || parentsUntil(target, 'e-grid').id)) {
                if (this.isDropGrid.element.querySelector('.e-emptyrow')) {
                    this.dragTarget = 0;
                }
                else {
                    this.dragTarget = parseInt(trElement.getAttribute('data-rowindex'), 10);
                }
            }
            else {
                this.dragTarget = parseInt(this.startedRow.getAttribute('data-rowindex'), 10);
            }
            if (gObj.rowDropSettings.targetID) {
                const dragParentElement = document.querySelector('.e-drag-ref');
                if (!parentsUntil(target, 'e-grid') || (dragParentElement
                    && parentsUntil(dragParentElement.parentElement, 'e-grid').id === parentsUntil(target, 'e-grid').id) ||
                    parentsUntil(cloneElement.parentElement, 'e-grid').id === parentsUntil(target, 'e-grid').id) {
                    classList(cloneElement, ['e-notallowedcur'], ['e-defaultcur']);
                }
                else {
                    classList(cloneElement, ['e-grabcur'], ['e-notallowedcur']);
                }
            }
            else {
                const elem = parentsUntil(target, 'e-grid');
                if (elem && elem.id === cloneElement.parentElement.id) {
                    classList(cloneElement, ['e-movecur'], ['e-defaultcur']);
                }
                else {
                    classList(cloneElement, ['e-notallowedcur'], ['e-movecur']);
                }
            }
            if (parentsUntil(this.isDropGrid.element, 'e-grid')) {
                if ((!this.isDropGrid.groupSettings.columns.length || this.isDropGrid.groupSettings.columns.length)
                    && !this.isDropGrid.element.querySelector('.e-emptyrow')) {
                    if (parentsUntil(target, 'e-grid') && parentsUntil(target, 'e-grid').id === this.isDropGrid.element.id) {
                        this.updateScrollPostion(e.event);
                    }
                    if (((this.isOverflowBorder || this.parent.frozenRows > this.dragTarget) &&
                        (parseInt(this.startedRow.getAttribute(literals.dataRowIndex), 10) !== this.dragTarget || this.istargetGrid))
                        || (this.istargetGrid && trElement && this.isDropGrid.getRowByIndex(this.isDropGrid.getCurrentViewRecords().length - 1).
                            getAttribute('data-uid') === trElement.getAttribute('data-uid'))) {
                        this.moveDragRows(e, this.startedRow, trElement);
                    }
                    else {
                        let islastRowIndex;
                        if (this.parent.enableVirtualization) {
                            islastRowIndex = trElement && parseInt(trElement.getAttribute(literals.dataRowIndex), 10) ===
                                this.parent.renderModule.data.dataManager.dataSource.json.length - 1;
                        }
                        else {
                            const lastRowUid = this.parent.getRowByIndex(this.parent.getCurrentViewRecords().length - 1).
                                getAttribute('data-uid');
                            islastRowIndex = trElement && lastRowUid === trElement.getAttribute('data-uid') && lastRowUid !==
                                this.startedRow.getAttribute('data-uid');
                        }
                        if (islastRowIndex && !this.parent.rowDropSettings.targetID) {
                            const bottomborder = this.parent.createElement('div', { className: 'e-lastrow-dragborder' });
                            const gridcontentEle = this.parent.getContent();
                            bottomborder.style.width = this.parent.element.offsetWidth - this.getScrollWidth() + 'px';
                            if (this.parent.enableVirtualization) {
                                bottomborder.style.zIndex = '1';
                            }
                            if (!gridcontentEle.getElementsByClassName('e-lastrow-dragborder').length &&
                                (!(gObj.allowGrouping && gObj.groupSettings.columns.length) || isNullOrUndefined(trElement.nextSibling))) {
                                gridcontentEle.classList.add('e-grid-relative');
                                gridcontentEle.appendChild(bottomborder);
                                bottomborder.style.bottom = this.getScrollWidth() + 'px';
                            }
                        }
                        this.removeBorder(trElement);
                    }
                }
                if (target && target.classList.contains(literals.content)
                    && !this.isDropGrid.element.querySelector('.e-emptyrow') && this.istargetGrid) {
                    this.removeBorder(trElement);
                    const rowIndex = this.isDropGrid.getCurrentViewRecords().length - 1;
                    const selector = '.e-rowcell,.e-rowdragdrop,.e-detailrowcollapse';
                    let rowElement = [];
                    rowElement = [].slice.call(this.isDropGrid.getRowByIndex(rowIndex).querySelectorAll(selector));
                    if (rowElement.length > 0) {
                        addRemoveActiveClasses(rowElement, true, 'e-dragborder');
                    }
                }
            }
        };
        this.dragStop = (e) => {
            document.body.classList.remove('e-prevent-select');
            if (isActionPrevent(this.parent)) {
                this.parent.notify(events.preventBatch, {
                    instance: this, handler: this.processDragStop, arg1: e
                });
            }
            else {
                this.processDragStop(e);
            }
        };
        this.processDragStop = (e) => {
            const gObj = this.parent;
            if (this.parent.isDestroyed) {
                return;
            }
            const targetEle = this.getElementFromPosition(e.helper, e.event);
            const target = targetEle && !targetEle.classList.contains('e-dlg-overlay') ?
                targetEle : e.target;
            gObj.element.classList.remove('e-rowdrag');
            const dropElement = document.getElementById(gObj.rowDropSettings.targetID);
            if (gObj.rowDropSettings.targetID && dropElement && dropElement.ej2_instances &&
                dropElement.ej2_instances[0].getModuleName() === 'grid') {
                dropElement.ej2_instances[0].getContent().classList.remove('e-allowRowDrop');
            }
            if (parentsUntil(this.isDropGrid.element, 'e-grid')) {
                this.stopTimer();
                this.isDropGrid.enableHover = this.hoverState;
                this.isDropGrid.getContent().classList.remove('e-grid-relative');
                this.removeBorder(targetEle);
                const stRow = this.isDropGrid.element.querySelector('.e-dragstartrow');
                if (stRow) {
                    stRow.classList.remove('e-dragstartrow');
                }
            }
            this.processArgs(target);
            const args = {
                target: target, draggableType: 'rows',
                cancel: false,
                fromIndex: parseInt(this.rows[0].getAttribute(literals.dataRowIndex), 10),
                dropIndex: this.dragTarget, rows: this.rows,
                data: (Object.keys(this.dragStartData[0]).length > 0) ? this.dragStartData : this.currentViewData()
            };
            gObj.trigger(events.rowDrop, args, () => {
                if (!(parentsUntil(target, literals.row) || parentsUntil(target, 'e-emptyrow')
                    || parentsUntil(target, literals.gridContent)) || args.cancel) {
                    this.dragTarget = null;
                    remove(e.helper);
                    return;
                }
                this.isRefresh = false;
                const selectedIndexes = this.parent.getSelectedRowIndexes();
                if (gObj.isRowDragable()) {
                    if (!this.parent.rowDropSettings.targetID &&
                        this.startedRow.querySelector('td.e-selectionbackground') && selectedIndexes.length > 1 &&
                        selectedIndexes.length !== this.parent.getCurrentViewRecords().length) {
                        this.reorderRows(selectedIndexes, args.dropIndex);
                    }
                    else {
                        this.reorderRows([parseInt(this.startedRow.getAttribute(literals.dataRowIndex), 10)], this.dragTarget);
                    }
                    this.dragTarget = null;
                    if (!gObj.rowDropSettings.targetID) {
                        if (e.helper.classList.contains('e-cloneproperties') && document.querySelector('.' + e.helper.classList[0])) {
                            remove(e.helper);
                        }
                        if (gObj.enableVirtualization && (!this.parent.allowGrouping || !gObj.groupSettings.columns.length)) {
                            gObj.refresh();
                        }
                        else {
                            this.rowOrder(args);
                        }
                    }
                    if (this.parent.getContentTable().scrollHeight < this.parent.getContent().clientHeight) {
                        this.parent.scrollModule.setLastRowCell();
                    }
                }
                this.isRefresh = true;
            });
        };
        this.removeCell = (targetRow, className) => {
            return [].slice.call(targetRow.querySelectorAll('td')).filter((cell) => {
                if (cell.classList.contains(className)) {
                    targetRow.deleteCell(cell.cellIndex);
                }
            });
        };
        this.parent = parent;
        if (this.parent.isDestroyed) {
            return;
        }
        this.parent.on(events.initialEnd, this.initializeDrag, this);
        this.parent.on(events.columnDrop, this.columnDrop, this);
        this.parent.on(events.rowDragAndDropComplete, this.onActionComplete, this);
        this.onDataBoundFn = this.onDataBound.bind(this);
        this.parent.addEventListener(events.dataBound, this.onDataBoundFn);
        this.parent.on(events.uiUpdate, this.enableAfterRender, this);
        this.parent.on(events.destroy, this.destroy, this);
    }
    getParentGrid(childGrid) {
        let parentGrid = childGrid;
        let parentGridObtained = false;
        while (!parentGridObtained) {
            if (parentGrid.ej2_instances[0].parentDetails) {
                parentGrid = document.getElementById(parentGrid.ej2_instances[0].parentDetails.parentID);
            }
            if (!parentGrid.classList.contains('e-childgrid')) {
                parentGridObtained = true;
            }
        }
        return parentGrid;
    }
    refreshRow(args, tbody, target) {
        const gObj = this.parent;
        const tbodyContent = gObj.getContentTable().querySelector(literals.tbody);
        const tbodyHeader = gObj.getHeaderTable().querySelector(literals.tbody);
        for (let i = 0, len = args.rows.length; i < len; i++) {
            if (gObj.enableVirtualization && gObj.allowGrouping && gObj.groupSettings.columns.length &&
                args.rows.length === 1) {
                const removeElem = gObj.getRowElementByUID(args.rows[parseInt(i.toString(), 10)].getAttribute('data-uid'));
                if (!isNullOrUndefined(removeElem)) {
                    remove(removeElem);
                }
            }
            tbody.insertBefore(args.rows[parseInt(i.toString(), 10)], target);
            if (gObj.allowGrouping && gObj.groupSettings.columns.length) {
                const dragRowUid = args.rows[parseInt(i.toString(), 10)].getAttribute('data-uid');
                const dropRowUid = args.target.parentElement.getAttribute('data-uid');
                const dragRowObject = gObj.getRowObjectFromUID(dragRowUid);
                const dropRowObject = gObj.getRowObjectFromUID(dropRowUid);
                if (dragRowObject.parentUid !== dropRowObject.parentUid) {
                    gObj['groupModule'].groupReorderHandler(dragRowObject, dropRowObject);
                }
            }
        }
        const tr = [].slice.call(tbody.getElementsByClassName(literals.row));
        if (!gObj.enableVirtualization && gObj.allowGrouping && gObj.groupSettings.columns.length) {
            gObj['groupModule'].groupReorderRowObject(args, tr);
            resetRowIndex(this.parent, gObj.getRowsObject().filter((data) => data.isDataRow), tr);
            this.parent.notify(events.refreshExpandandCollapse, { rows: this.parent.getRowsObject() });
        }
        else if (gObj.enableVirtualization && gObj.allowGrouping && gObj.groupSettings.columns.length) {
            gObj['groupModule'].groupReorderRowObject(args, tr);
            gObj['groupModule'].vGroupResetRowIndex();
            this.parent.notify(events.refreshExpandandCollapse, { rows: this.parent.vRows });
        }
        else {
            this.refreshData(tr);
        }
        if (this.parent.frozenRows) {
            for (let i = 0, len = tr.length; i < len; i++) {
                if (i < this.parent.frozenRows) {
                    tbodyHeader.appendChild(tr[parseInt(i.toString(), 10)]);
                }
                else {
                    tbodyContent.appendChild(tr[parseInt(i.toString(), 10)]);
                }
            }
        }
    }
    updateFrozenRowreOrder(args) {
        const gObj = this.parent;
        const tbodyC = gObj.getContentTable().querySelector(literals.tbody);
        const tbodyH = gObj.getHeaderTable().querySelector(literals.tbody);
        const tr = [].slice.call(tbodyH.getElementsByClassName(literals.row)).concat([].slice.call(tbodyC.getElementsByClassName(literals.row)));
        const tbody = gObj.createElement(literals.tbody, { attrs: { role: 'rowgroup' } });
        this.parent.clearSelection();
        const targetRow = this.refreshRowTarget(args);
        for (let i = 0, len = tr.length; i < len; i++) {
            tbody.appendChild(tr[parseInt(i.toString(), 10)]);
        }
        this.refreshRow(args, tbody, targetRow);
    }
    refreshRowTarget(args) {
        const gObj = this.parent;
        let targetIdx = parseInt(args.target.parentElement.getAttribute(literals.dataRowIndex), 10);
        if (gObj.enableVirtualization && gObj.allowGrouping && gObj.groupSettings.columns.length) {
            targetIdx = this.parent.getDataRows().indexOf(args.target.parentElement);
        }
        if ((args.fromIndex < args.dropIndex || args.fromIndex === args.dropIndex) && (!gObj.allowGrouping ||
            !gObj.groupSettings.columns.length)) {
            targetIdx = targetIdx + 1;
        }
        const tr = gObj.allowGrouping && gObj.groupSettings.columns.length && targetIdx !== -1 &&
            args.fromIndex < args.dropIndex ? gObj.getRowByIndex(targetIdx).nextSibling : gObj.getRowByIndex(targetIdx);
        return tr;
    }
    updateFrozenColumnreOrder(args) {
        const gObj = this.parent;
        const tbody = gObj.getContentTable().querySelector(literals.tbody);
        this.parent.clearSelection();
        const targetRow = this.refreshRowTarget(args);
        this.refreshRow(args, tbody, targetRow);
    }
    refreshData(tr) {
        const rowObj = {};
        const recordobj = {};
        const rowObjects = this.parent.getRowsObject();
        const currentViewData = this.parent.getCurrentViewRecords();
        for (let i = 0, len = tr.length; i < len; i++) {
            const index = parseInt(tr[parseInt(i.toString(), 10)].getAttribute(literals.dataRowIndex), 10);
            rowObj[parseInt(i.toString(), 10)] = rowObjects[parseInt(index.toString(), 10)];
            recordobj[parseInt(i.toString(), 10)] = currentViewData[parseInt(index.toString(), 10)];
        }
        const rows = this.parent.getRows();
        for (let i = 0, len = tr.length; i < len; i++) {
            rows[parseInt(i.toString(), 10)] = tr[parseInt(i.toString(), 10)];
            rowObjects[parseInt(i.toString(), 10)] = rowObj[parseInt(i.toString(), 10)];
            currentViewData[parseInt(i.toString(), 10)] = recordobj[parseInt(i.toString(), 10)];
        }
        resetRowIndex(this.parent, rowObjects, tr);
    }
    rowOrder(args) {
        if (args.dropIndex === args.fromIndex || isNaN(args.dropIndex)) {
            return;
        }
        if (this.parent.isDetail()) {
            this.parent.detailCollapseAll();
            const rows = [].slice.call(this.parent.getContentTable().querySelector(literals.tbody).children);
            const rowObjects = this.parent.getRowsObject();
            rows.filter((row) => {
                if (row.classList.contains('e-detailrow')) {
                    row.remove();
                }
            });
            for (let i = 0, len = rowObjects.length; i < len; i++) {
                if (!rowObjects[parseInt(i.toString(), 10)]) {
                    break;
                }
                if (rowObjects[parseInt(i.toString(), 10)].isDetailRow) {
                    this.parent.getRowsObject().splice(i, 1);
                    i--;
                }
            }
        }
        if (args.target.classList.contains('e-rowcelldrag') || args.target.classList.contains('e-dtdiagonalright')
            || args.target.classList.contains('e-dtdiagonaldown')) {
            args.target = args.target.parentElement;
        }
        if (!args.target.classList.contains('e-rowcell') && parentsUntil(args.target, 'e-rowcell')) {
            args.target = parentsUntil(args.target, 'e-rowcell');
        }
        if (this.parent.frozenRows) {
            this.updateFrozenRowreOrder(args);
        }
        else {
            this.updateFrozenColumnreOrder(args);
        }
        if ((!this.parent.allowGrouping || !this.parent.groupSettings.columns.length) && this.selectedRowColls.length > 0) {
            this.parent.selectRows(this.selectedRowColls);
            const indexes = [];
            if (this.parent.filterSettings.columns.length || this.parent.sortSettings.columns.length) {
                for (let i = 0, len = args.rows.length; i < len; i++) {
                    indexes.push(parseInt(args.rows[parseInt(i.toString(), 10)].getAttribute(literals.dataRowIndex), 10));
                }
                this.selectedRowColls = indexes;
            }
            this.selectedRowColls = [];
        }
    }
    currentViewData() {
        const selectedIndexes = this.parent.getSelectedRowIndexes();
        const currentVdata = [];
        const fromIdx = parseInt(this.startedRow.getAttribute(literals.dataRowIndex), 10);
        for (let i = 0, n = selectedIndexes.length; i < n; i++) {
            const currentV = 'currentViewData';
            currentVdata[parseInt(i.toString(), 10)] = this.parent[`${currentV}`][selectedIndexes[parseInt(i.toString(), 10)]];
        }
        if (!this.parent.rowDropSettings.targetID && selectedIndexes.length === 0) {
            currentVdata[0] = this.parent.currentViewData[parseInt(fromIdx.toString(), 10)];
        }
        return currentVdata;
    }
    saveChange(changeRecords, query) {
        this.parent.getDataModule().saveChanges(changeRecords, this.parent.getPrimaryKeyFieldNames()[0], {}, query)
            .then(() => {
            this.parent.notify(events.modelChanged, {
                type: events.actionBegin, requestType: 'rowdraganddrop'
            });
        }).catch((e) => {
            const error = 'error';
            const message = 'message';
            if (!isNullOrUndefined(e[`${error}`]) && !isNullOrUndefined(e[`${error}`][`${message}`])) {
                e[`${error}`] = e[`${error}`][`${message}`];
            }
            this.parent.trigger(events.actionFailure, e);
        });
    }
    reorderRows(fromIndexes, toIndex) {
        const selectedIndexes = this.parent.getSelectedRowIndexes();
        const selectedRecords = [];
        const draggedRecords = [];
        const currentViewData = this.parent.renderModule.data.dataManager.dataSource.json;
        const skip = this.parent.allowPaging ?
            (this.parent.pageSettings.currentPage * this.parent.pageSettings.pageSize) - this.parent.pageSettings.pageSize : 0;
        let dropIdx = toIndex + skip;
        let actualIdx = fromIndexes[0] + skip;
        for (let i = 0, len = fromIndexes.length; i < len; i++) {
            draggedRecords[parseInt(i.toString(), 10)] = currentViewData[fromIndexes[parseInt(i.toString(), 10)] + skip];
        }
        for (let i = 0, len = selectedIndexes.length; i < len; i++) {
            selectedRecords[parseInt(i.toString(), 10)] = currentViewData[selectedIndexes[parseInt(i.toString(), 10)] + skip];
        }
        for (let i = 0, len = draggedRecords.length; i < len; i++) {
            if (i !== 0) {
                for (let j = 0, len1 = currentViewData.length; j < len1; j++) {
                    if (JSON.stringify(this.parent.renderModule.data.dataManager.dataSource.json[parseInt(j.toString(), 10)]) ===
                        JSON.stringify(draggedRecords[parseInt(i.toString(), 10)])) {
                        actualIdx = j;
                        break;
                    }
                }
                for (let j = 0, len1 = currentViewData.length; j < len1; j++) {
                    if (JSON.stringify(this.parent.renderModule.data.dataManager.dataSource.json[parseInt(j.toString(), 10)]) === JSON
                        .stringify(draggedRecords[i - 1])) {
                        if (actualIdx > j) {
                            dropIdx = j + 1;
                        }
                        break;
                    }
                }
            }
            this.reorderRow(actualIdx - skip, dropIdx - skip);
        }
        if (this.isRefresh) {
            this.parent.notify(events.modelChanged, {
                type: events.actionBegin, requestType: 'rowdraganddrop'
            });
        }
        for (let i = 0, len = selectedRecords.length; i < len; i++) {
            for (let j = 0, len1 = currentViewData.length; j < len1; j++) {
                if (JSON.stringify(this.parent.renderModule.data.dataManager.dataSource.json[parseInt(j.toString(), 10)]) === JSON
                    .stringify(selectedRecords[parseInt(i.toString(), 10)])) {
                    selectedIndexes[parseInt(i.toString(), 10)] = j - skip;
                    break;
                }
            }
        }
        this.selectedRowColls = selectedIndexes;
    }
    stopTimer() {
        window.clearInterval(this.timer);
    }
    /**
     * To trigger action complete event.
     *
     * @param {NotifyArgs} e - specifies the NotifyArgs
     * @returns {void}
     * @hidden
     */
    onActionComplete(e) {
        this.parent.trigger(events.actionComplete, extend(e, { type: events.actionComplete, requestType: 'rowdraganddrop' }));
    }
    initializeDrag() {
        const gObj = this.parent;
        this.draggable = new Draggable(gObj.element, {
            dragTarget: '.e-rowcelldrag, .e-rowdragdrop, .e-rowcell',
            distance: 5,
            helper: this.helper,
            dragStart: this.dragStart,
            drag: this.drag,
            dragStop: this.dragStop,
            isReplaceDragEle: this.isReplaceDragEle,
            isPreventSelect: false
        });
    }
    updateScrollPostion(e) {
        const y = getPosition(e).y;
        const cliRect = this.isDropGrid.getContent().getBoundingClientRect();
        const rowHeight = this.isDropGrid.getRowHeight() - 15;
        const scrollElem = this.isDropGrid.getContent().firstElementChild;
        const virtualScrollbtm = this.parent.enableVirtualization ? 20 : 0;
        if (cliRect.top >= y) {
            const scrollPixel = -(this.isDropGrid.getRowHeight());
            this.isOverflowBorder = false;
            this.timer = window.setInterval(() => { this.setScrollDown(scrollElem, scrollPixel); }, 200);
        }
        else if (cliRect.top + this.isDropGrid.getContent().clientHeight - rowHeight - 33 - virtualScrollbtm <= y) {
            const scrollPixel = (this.isDropGrid.getRowHeight());
            this.isOverflowBorder = false;
            this.timer = window.setInterval(() => { this.setScrollDown(scrollElem, scrollPixel); }, 200);
        }
    }
    setScrollDown(scrollElem, scrollPixel) {
        scrollElem.scrollTop = scrollElem.scrollTop + scrollPixel;
    }
    moveDragRows(e, startedRow, targetRow) {
        let cloneElement = this.parent.element.querySelector('.e-cloneproperties');
        if (this.parent.element.classList.contains('e-childgrid')) {
            const parentGrid = this.getParentGrid(this.parent.element);
            cloneElement = parentGrid.querySelector('.e-cloneproperties');
        }
        const element = closestElement(e.target, 'tr');
        if (parentsUntil(element, 'e-grid') &&
            ((!this.parent.rowDropSettings.targetID &&
                parentsUntil(cloneElement.parentElement, 'e-grid').id === parentsUntil(element, 'e-grid').id) || this.istargetGrid)) {
            let targetElement = element;
            if (!element) {
                targetElement = startedRow;
            }
            this.setBorder(targetElement, e.event, startedRow, targetRow);
        }
    }
    setBorder(element, event, startedRow, targetRow) {
        let node = this.parent.element;
        if (this.istargetGrid) {
            node = this.isDropGrid.element;
        }
        const cloneElement = this.parent.element.querySelector('.e-cloneproperties');
        if (this.parent.allowGrouping && this.parent.groupSettings.columns.length) {
            this.removeBorder(element);
        }
        else {
            this.removeFirstRowBorder(element);
            this.removeLastRowBorder(element);
        }
        if (parentsUntil(element, 'e-grid') && element.classList.contains(literals.row) && ((!this.parent.rowDropSettings.targetID &&
            parentsUntil(cloneElement.parentElement, 'e-grid').id === parentsUntil(element, 'e-grid').id) || this.istargetGrid)) {
            removeClass(node.querySelectorAll('.e-rowcell,.e-rowdragdrop,.e-detailrowcollapse'), ['e-dragborder']);
            let rowElement = [];
            let targetRowIndex = parseInt(targetRow.getAttribute(literals.dataRowIndex), 10);
            if (targetRow && targetRowIndex === 0) {
                if (this.parent.allowGrouping && this.parent.groupSettings.columns.length) {
                    element = targetRow.previousSibling;
                    rowElement = [].slice.call(element
                        .querySelectorAll('.e-groupcaption,.e-summarycell,.e-rowcell,.e-rowdragdrop,.e-detailrowcollapse'));
                }
                else {
                    const div = this.parent.createElement('div', { className: 'e-firstrow-dragborder' });
                    const gridheaderEle = this.isDropGrid.getHeaderContent();
                    gridheaderEle.classList.add('e-grid-relative');
                    div.style.width = node.offsetWidth - this.getScrollWidth() + 'px';
                    if (!gridheaderEle.getElementsByClassName('e-firstrow-dragborder').length) {
                        if (this.parent.frozenRows) {
                            if (this.parent.isFrozenGrid()) {
                                div.style.width = this.parent.getContent().firstElementChild.scrollWidth + 'px';
                            }
                            gridheaderEle.querySelector('thead').appendChild(div);
                            div.style.position = 'relative';
                        }
                        else {
                            gridheaderEle.appendChild(div);
                        }
                    }
                }
            }
            else if (this.parent.rowDropSettings.targetID && targetRow) {
                element = this.isDropGrid.getRowByIndex(targetRowIndex - 1);
                rowElement = [].slice.call(element.querySelectorAll('.e-rowcell,.e-rowdragdrop,.e-detailrowcollapse'));
            }
            else if (targetRow && parseInt(startedRow.getAttribute(literals.dataRowIndex), 10) > targetRowIndex) {
                if (this.parent.enableVirtualization && this.parent.allowGrouping && this.parent.groupSettings.columns.length) {
                    targetRowIndex = this.parent.getDataRows().indexOf(targetRow);
                }
                if (this.parent.allowGrouping && this.parent.groupSettings.columns.length &&
                    targetRow.previousSibling.classList.contains('e-groupcaptionrow')) {
                    element = targetRow.previousSibling;
                    rowElement = [].slice.call(element
                        .querySelectorAll('.e-groupcaption,.e-summarycell,.e-rowcell,.e-rowdragdrop,.e-detailrowcollapse'));
                }
                else {
                    element = this.parent.getRowByIndex(targetRowIndex - 1);
                    rowElement = [].slice.call(element.querySelectorAll('.e-rowcell,.e-rowdragdrop,.e-detailrowcollapse'));
                }
            }
            else {
                rowElement = [].slice.call(element.querySelectorAll('.e-rowcell,.e-rowdragdrop,.e-detailrowcollapse'));
            }
            if (rowElement.length > 0) {
                addRemoveActiveClasses(rowElement, true, 'e-dragborder');
            }
        }
    }
    getScrollWidth() {
        const scrollElem = this.parent.getContent().firstElementChild;
        return scrollElem.scrollWidth > scrollElem.offsetWidth ? Scroll.getScrollBarWidth() : 0;
    }
    removeFirstRowBorder(element) {
        if (this.isDropGrid.element.getElementsByClassName('e-firstrow-dragborder').length > 0 && element &&
            element.rowIndex !== 0) {
            remove(this.isDropGrid.element.getElementsByClassName('e-firstrow-dragborder')[0]);
        }
    }
    removeLastRowBorder(element) {
        let islastRowIndex;
        if (this.parent.enableVirtualization) {
            islastRowIndex = element && parseInt(element.getAttribute(literals.dataRowIndex), 10) !==
                this.parent.renderModule.data.dataManager.dataSource.json.length - 1;
        }
        else {
            islastRowIndex = element &&
                this.parent.getRowByIndex(this.parent.getCurrentViewRecords().length - 1).getAttribute('data-uid') !==
                    element.getAttribute('data-uid');
        }
        if (this.parent.element.getElementsByClassName('e-lastrow-dragborder').length > 0 && element && islastRowIndex) {
            remove(this.parent.element.getElementsByClassName('e-lastrow-dragborder')[0]);
        }
    }
    removeBorder(element) {
        this.removeFirstRowBorder(element);
        if (!this.parent.rowDropSettings.targetID) {
            this.removeLastRowBorder(element);
        }
        if (this.parent.allowGrouping && this.parent.groupSettings.columns.length) {
            element = ([].slice.call(this.isDropGrid.getContentTable().querySelectorAll('tr'))).filter((row) => row.querySelector('td.e-dragborder'))[0];
        }
        else {
            element = (this.isDropGrid.getRows()).filter((row) => row.querySelector('td.e-dragborder'))[0];
        }
        if (element) {
            const rowElement = [].slice.call(element.getElementsByClassName('e-dragborder'));
            addRemoveActiveClasses(rowElement, false, 'e-dragborder');
        }
    }
    getElementFromPosition(element, event) {
        const position = getPosition(event);
        element.style.display = 'none';
        const target = document.elementFromPoint(position.x, position.y);
        element.style.display = '';
        return target;
    }
    onDataBound() {
        if (this.selectedRowColls.length > 0 && (this.parent.enableVirtualization || this.parent.allowRowDragAndDrop)) {
            this.parent.selectRows(this.selectedRowColls);
            this.selectedRowColls = [];
        }
    }
    getTargetIdx(targetRow) {
        return targetRow ? parseInt(targetRow.getAttribute(literals.dataRowIndex), 10) : 0;
    }
    singleRowDrop(e) {
        const targetRow = closestElement(e.target, 'tr');
        const srcControl = e.droppedElement.parentElement.ej2_instances[0];
        const currentIndex = targetRow ? targetRow.rowIndex : srcControl.currentViewData.length - 1;
        this.reorderRow(this.startedRowIndex, currentIndex);
    }
    columnDrop(e) {
        const gObj = this.parent;
        if (e.droppedElement.getAttribute('action') !== 'grouping' &&
            (parentsUntil(e.target, literals.row) || parentsUntil(e.target, 'e-emptyrow') || parentsUntil(e.target, literals.gridContent))) {
            const targetRow = closestElement(e.target, 'tr');
            let srcControl;
            let currentIndex;
            const dragParentElement = document.querySelector('.e-drag-ref');
            if ((e.droppedElement.querySelector('tr').getAttribute('single-dragrow') !== 'true' &&
                (e.droppedElement.parentElement.id === gObj.element.id || (dragParentElement
                    && dragParentElement.parentElement.id === gObj.element.id)))
                || (e.droppedElement.querySelector('tr').getAttribute('single-dragrow') === 'true' &&
                    e.droppedElement.parentElement.id !== gObj.element.id)) {
                return;
            }
            if (e.droppedElement.parentElement.id !== gObj.element.id) {
                if (dragParentElement) {
                    srcControl = dragParentElement.parentElement.ej2_instances[0];
                    remove(dragParentElement);
                }
                else {
                    srcControl = e.droppedElement.parentElement.ej2_instances[0];
                }
            }
            else if (this.isSingleRowDragDrop || e.droppedElement.querySelector('tr').getAttribute('single-dragrow') === 'true') {
                this.singleRowDrop(e);
                return;
            }
            if (srcControl.element.id !== gObj.element.id && srcControl.rowDropSettings.targetID !== gObj.element.id) {
                return;
            }
            const records = srcControl.getSelectedRecords();
            let targetIndex = currentIndex = this.getTargetIdx(targetRow);
            if (isNaN(targetIndex)) {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                targetIndex = currentIndex = 0;
            }
            if (gObj.allowPaging) {
                targetIndex = targetIndex + (gObj.pageSettings.currentPage * gObj.pageSettings.pageSize) - gObj.pageSettings.pageSize;
            }
            //Todo: drag and drop mapper & BatchChanges
            gObj.notify(events.rowsAdded, { toIndex: targetIndex, records: records });
            gObj.notify(events.modelChanged, {
                type: events.actionBegin, requestType: 'rowdraganddrop'
            });
            const selectedRows = srcControl.getSelectedRowIndexes();
            const skip = srcControl.allowPaging ?
                (srcControl.pageSettings.currentPage * srcControl.pageSettings.pageSize) - srcControl.pageSettings.pageSize : 0;
            this.selectedRows = [];
            for (let i = 0, len = records.length; i < len; i++) {
                this.selectedRows.push(skip + selectedRows[parseInt(i.toString(), 10)]);
            }
            srcControl.notify(events.rowsRemoved, { indexes: this.selectedRows, records: records });
            srcControl.notify(events.modelChanged, {
                type: events.actionBegin, requestType: 'rowdraganddrop'
            });
        }
    }
    reorderRow(fromIndexes, toIndex) {
        const gObj = this.parent;
        if (!gObj.sortSettings.columns.length && !gObj.groupSettings.columns.length && !gObj.filterSettings.columns.length) {
            //Todo: drag and drop mapper & BatchChanges
            const skip = gObj.allowPaging ?
                (gObj.pageSettings.currentPage * gObj.pageSettings.pageSize) - gObj.pageSettings.pageSize : 0;
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const fromIndex = fromIndexes;
            toIndex = toIndex + skip;
            this.selectedRows = gObj.getSelectedRowIndexes();
            gObj.notify(events.rowPositionChanged, {
                fromIndex: fromIndexes + skip,
                toIndex: toIndex
            });
        }
    }
    enableAfterRender(e) {
        if (e.module === this.getModuleName() && e.enable) {
            this.initializeDrag();
        }
    }
    /**
     * To destroy the print
     *
     * @returns {void}
     * @hidden
     */
    destroy() {
        const gridElement = this.parent.element;
        if (this.parent.isDestroyed || !gridElement || (!gridElement.querySelector('.' + literals.gridHeader) &&
            !gridElement.querySelector('.' + literals.gridContent))) {
            return;
        }
        this.draggable.destroy();
        this.parent.off(events.initialEnd, this.initializeDrag);
        this.parent.off(events.columnDrop, this.columnDrop);
        this.parent.off(events.rowDragAndDropComplete, this.onActionComplete);
        this.parent.removeEventListener(events.dataBound, this.onDataBoundFn);
        this.parent.off(events.uiUpdate, this.enableAfterRender);
        this.parent.off(events.destroy, this.destroy);
        //destory ejdrag and drop
    }
    /**
     * For internal use only - Get the module name.
     *
     * @returns {string} returns the module name
     * @private
     */
    getModuleName() {
        return 'rowDragAndDrop';
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    processArgs(target) {
        const gObj = this.parent;
        const dragIdx = parseInt(this.startedRow.getAttribute(literals.dataRowIndex), 10);
        if ((gObj.getSelectedRecords().length > 0 && this.startedRow.cells[0].classList.contains('e-selectionbackground') === false)
            || gObj.getSelectedRecords().length === 0) {
            if (this.parent.enableVirtualization) {
                this.rows = [this.startedRow];
            }
            else {
                this.rows = [this.parent.getRowByIndex(dragIdx)];
            }
            this.rowData = [this.parent.getRowInfo((this.startedRow).querySelector('.' + literals.rowCell)).rowData];
            if (gObj.enableVirtualization && gObj.allowGrouping && gObj.groupSettings.columns.length &&
                gObj.getSelectedRows().length) {
                this.rows = gObj.getSelectedRows();
                this.rowData = gObj.getSelectedRecords();
            }
        }
        else {
            this.rows = gObj.getSelectedRows();
            this.rowData = gObj.getSelectedRecords();
        }
    }
}
